export const REFRESH_ORDERS = 'REFRESH_ORDERS';
export const refreshOrders = (data) => ({
  type: REFRESH_ORDERS,
  data,
});
